<template>
  <div>
    <div class="btns-container">
      <router-link
        to="/dashboard-grfa/details/suivi-rfa"
        class="btn-cmem"
        :class="{active: $route.path.includes('suivi-rfa') || $route.path == '/dashboard-grfa/details'}"
      >
        RFA
      </router-link>
<!--      <router-link-->
<!--        to="/dashboard-grfa/details/suivi-contrats"-->
<!--        class="btn-cmem"-->
<!--        :class="{active: $route.path.includes('suivi-contrats')}"-->
<!--      >-->
<!--        Contrats-->
<!--      </router-link>-->
    </div>
    <div class="details-content">
      <router-view :year="parseInt(year)" :detailed-periods="detailedPeriods"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "Details",
  props: ["year", "detailedPeriods"],
  data() {
    return {};
  },
  watch: {},
  methods: {},
  computed: {}
}
</script>

<style scoped>
.btns-container {
  display: flex;
  gap: 12px;
}

.btn-cmem {
  text-decoration: none;
}

.btn-cmem:not(.active) {
  background-color: white;
}

.details-content {
  margin-top: 12px;
}
</style>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/RFA/DashboardGRFA/Details/Details.vue